import { KeyboardEvent } from 'react'
const UP = 'ArrowUp'
const DOWN = 'ArrowDown'
const TAB = 'Tab'

const findNextFocusableSibling = (elem: HTMLElement): HTMLElement | null => {
  if (!elem.nextSibling) {
    return null
  }
  const nextSibling = elem.nextSibling as HTMLElement
  return nextSibling.tabIndex >= 0
    ? nextSibling
    : findNextFocusableSibling(nextSibling)
}

const findPreviousFocusableSibling = (
  elem: HTMLElement
): HTMLElement | null => {
  if (!elem.previousSibling) {
    return null
  }
  const previousSibling = elem.previousSibling as HTMLElement
  return previousSibling.tabIndex >= 0
    ? previousSibling
    : findPreviousFocusableSibling(previousSibling)
}

export const handleNavigationKeys = (event: KeyboardEvent) => {
  const elem = event.target as HTMLElement

  if (event.key === DOWN || (event.key === TAB && !event.shiftKey)) {
    event.preventDefault()
    const nextSibling = findNextFocusableSibling(elem)
    if (nextSibling) {
      nextSibling.focus()
    }
  }

  if (event.key === UP) {
    event.preventDefault()
    const previousSibling = findPreviousFocusableSibling(elem)
    if (previousSibling) {
      previousSibling.focus()
    }
  }
}
